<template>
  <div class="bot-main">
    <div class="part4">
      <div class="part4-line"></div>
      <div class="part4-fot">
        <div class="part4-fot-text">
          Esing Printing is a supplier of high quality custom planners/journals/notebooks
          place of registration: China, Registered office:No. 2,
          Huatian Road,Huayuan Industrial Park ,Binhai High Tech District,Tianjin,China
        </div>
        <div class="part4-fot-text">© Esing printing 2024 All rights reserved</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "BotFooter",
  components: {},
  data() {
    return{}
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style scoped>
.bot-main {
  width: 100%;
  box-sizing: border-box;
}
.part4 {
  width: 1920px;
  height: 100px;
  background-color: #e6e8e8;
  padding: 34px 0 26px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.part4-line {
  width: 100%;
  height: 1px;
  background-color: #8e9c9d;
}
.part4-fot {
  width: 1110px;
  text-align: center;
  font-size: 12px;
  color: #293744;
}
</style>
